const scrollButton = document.querySelector(".carousel__scroll");
if (scrollButton) {
  const carousel = document.querySelector(".carousel");
  scrollButton.addEventListener("click", function () {
    window.scrollTo(0, carousel.scrollHeight);
  });
}
